import { API, Auth } from 'aws-amplify';

export const callCalculateVitalsAbnormalities = async (input: any): Promise<string> => {
    try {
        const response: any = await API.post('EDPlatformAPI', '/api/calculate-vitals-abnormalities', {
            body: {
                arguments: {
                    input: JSON.stringify(input),
                }
            },
            headers: {
                'Content-Type': 'application/json',
            }
        });

        console.log('callCalculateVitalsAbnormalities response', JSON.parse(response.body.response));
        return response.body.response;
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callCalculateVitalsAbnormalities");
        return "";
    }
}
